<template>
  <div class="ListeEvolAffaires mb-5">
   <div class="container">
    
    <div class="encart">
      <h2>Mes brouillons</h2>
      <div v-if="evolutions.length > 0">
        <ul>
          <li v-for="item in evolutions" :key="item.id">
            <div class="item">
              {{ item.nouvelle_description }}
              <span class="small">(brouillon enregistré le {{ formatDate(item.date_demande) }})</span>
            </div>
            <div class="actionsAdmin">
              <a href="#" @click.prevent="consulterEvolution(item.id)">Modifier le brouillon</a>
              <a href="#" @click.prevent="supprimerBrouillon(item.id)">Supprimer</a>
            </div>
          </li>
        </ul>
      </div>

      <!-- 🟢 Message affiché quand aucun brouillon -->
      <div v-else class="no-brouillons">
        <p>📝 Aucun brouillon enregistré pour le moment.</p>
        <p class="hint">Vous pouvez démarrer une nouvelle évolution d'affaire à tout moment.</p>
      </div>
    </div>
    
  
    
   </div>
    
      

  </div>
    
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'



export default {
  data() {
    return {
      evolutions: [],
      loggedInEmail: null,
    }
  },
  created() {
    const email = VueCookies.get('email')
    if (email) {
      this.loggedInEmail = email
    }
  },
  mounted() {
    

    axios.post('https://www.simef.fr/espace-client/api/getEvolAffaires.php', {
      email: this.loggedInEmail,

    })
    .then(response => {
      this.evolutions = response.data;
    })
    .catch(error => {
      console.error(error);
      
    });
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const optionsDate = { day: 'numeric', month: 'long', year: 'numeric' };
      const optionsHeure = { hour: '2-digit', minute: '2-digit' };

      const formattedDate = date.toLocaleDateString('fr-FR', optionsDate);
      const formattedTime = date.toLocaleTimeString('fr-FR', optionsHeure);

      return `${formattedDate} à ${formattedTime}`;
    },
    async consulterEvolution(id) {
      // Émet un événement vers le parent
      this.$emit('consulter-evolution', id);
    },
    async supprimerBrouillon(id) {
      if (!confirm("Souhaitez-vous vraiment supprimer ce brouillon ?")) return;

      try {
        const { data } = await axios.post(
          'https://www.simef.fr/espace-client/api/deleteBrouillon.php',
          { id }
        );

        if (data.success) {
          alert('✅ Brouillon supprimé avec succès');
          // Retire directement le brouillon du tableau sans attendre le reload
          this.evolutions = this.evolutions.filter(e => e.id !== id);
        } else {
          alert('❌ ' + (data.error || "Erreur lors de la suppression"));
        }
      } catch (error) {
        console.error('Erreur Axios :', error);
        alert("⚠️ Erreur lors de la suppression du brouillon");
      }
    },
  }
  
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $primary: #2b358d;
  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 0.4rem;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 1.1rem;
    }
  }
  .small, small {
    font-size: .9rem;
    display: inline;
    padding: 0;
    font-weight: 700;
  }
  .actionsAdmin a {
    margin: 0px !important;
    background: #2b358d;
    color: #fff !important;
    padding: 5px 20px;
  }
  .actionsAdmin {
    display: flex;
    column-gap: 1rem;
  }
</style>
